import React from 'react';

import { useCurrentUser } from '~/hooks/useCurrentUser';
import { checkIsAdmin } from '~/permissions/checkIsAdmin';
import { useRouting } from '~/routing/useRouting';

import { ClauseLibraryPage } from './ClauseLibraryPage/index';
import { TabValue } from './types';
import { formatUrl } from './utils';
import { WelcomePage } from './WelcomePage/index';

export const ClauseLibrary = () => {
  const { navigate, getSearchParam } = useRouting();
  const tab = getSearchParam<TabValue>('tab');

  const currentUser = useCurrentUser();
  const isAdmin = checkIsAdmin(currentUser);

  const clauseSummariesData = []; // placeholder

  const isWelcomeEnabled = !tab && isAdmin && clauseSummariesData.length === 0;

  const handleContinue = () => {
    navigate(formatUrl('ai-suggested'));
  };

  const handleSkip = () => {
    navigate(formatUrl('published'));
  };

  if (isWelcomeEnabled) {
    return <WelcomePage onContinue={handleContinue} onSkip={handleSkip} />;
  }

  return <ClauseLibraryPage />;
};
